import { axiosInstance } from './axios-instance';
import * as endpoints from "./../constants/api-constants";

class NotificationService {
  static activeNotification(payload, config) {
    return axiosInstance.post(endpoints.userNotification, payload, config).then(resp => resp.data)
  }

  static notificationsSettings(config) {
    return axiosInstance.get(endpoints.userNotificationSettigns, config).then(resp => resp.data)
  }

  static activeNotificationSettings(payload, config) {
    return axiosInstance.post(endpoints.notificationSettingsState, payload, config).then(resp => resp.data)
  }

  static getListNotifications(payload, config) {
    return axiosInstance.get(endpoints.listNotifications + '/?' +
      'page=' + payload.page + '&' +
      'size=' + payload.size + '&' +
      'segment=' + payload.segment
      , config).then(resp => resp.data)
  }

  static updateNotifications(payload, config) {
    return axiosInstance.put(endpoints.listNotifications, payload, config).then(resp => resp.data)
  }
}

export default NotificationService;